import React from 'react';
import { cn } from '../../ui/utils';

const ConnectionIndicator = ({ isOnline }) => {
  return (
    <div
      className={cn(
        // Keep header clear for the timer on mobile; show status from md up
        'hidden items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium transition-colors md:inline-flex',
        isOnline
          ? 'border-emerald-200/80 bg-emerald-50 text-emerald-700'
          : 'border-amber-200 bg-amber-50 text-amber-800'
      )}
      role="status"
      aria-live="polite"
      title={isOnline ? 'Online — ready to submit' : 'Offline — check your connection'}
    >
      <span className="relative flex h-2 w-2 shrink-0" aria-hidden>
        {isOnline && (
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-40" />
        )}
        <span
          className={cn(
            'relative inline-flex h-2 w-2 rounded-full',
            isOnline ? 'bg-emerald-500' : 'bg-amber-500'
          )}
        />
      </span>
      <span>{isOnline ? 'Online' : 'Offline'}</span>
    </div>
  );
};

export default ConnectionIndicator;
